module.exports = __webpack_public_path__ + "static/img/17.2e3f796.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/17.png
// module id = 2Pgi
// module chunks = 0